<cx-window
    i18n-title="@@benchmark-benchmark-dashboard.favourites.window.titel"
    title="Datapoints"
    [height]="400"
    [width]="250"
    class="benchmark-dashboard.favourites.window"
    name="benchmark-benchmark-dashboard.favourites.window"
    test-id="benchmark-benchmark-dashboard.favourites.window"
>

    <div class="toolbar" #tileToolbar>
        <button
            class="default icon fa fa-plus-square toolbar-button add-datapoints-button"
            title="Add datapoint"
            i18n-title="@@benchmark-dashboard.tile-properties.tab.add-datapoint"
            (click)="chooseDatapoints()"
            [attr.disabled]="(maxDatapoints <= datapointIds?.length) ? true : null"
            test-id="benchmark-dashboard.tile-properties.window.add-datapoint.button"
        ></button>
        <clx-overlay-container
            [opener]="dummy"
            [(open)]="isDatapointsSelectionOpen"
            class="datapoint-overlay"
            [closeOnClickOutside]="true"
        >
            <h4 i18n="@@benchmark-dashboard.tile-properties.datapoints.choose-datapoint.title">Choose Datapoint</h4>
            <clx-datapoint-selection
                [mode]="isSystemMode ? 'systems' : 'plant'" show="viewNode"
                show="datapoint"
                (selection)="addDatapoint($event)"
                *ngIf="isDatapointsSelectionOpen"
                #datapoints
                test-id="benchmark-dashboard.tile-properties.window.datapoint.datapointselection"
                [blacklist]="datapointIds"
                [enableFilter]="true"
                name="tileeditor-chart-datapoints-choose"
            ></clx-datapoint-selection>
        </clx-overlay-container>
    </div>
    <div #dummy></div>
    <clx-sortable-list is="datapoint-list" (valuesChanged)="datapointListChanged($event)">
        <clx-list-item 
            *ngFor="let datapoint of storage.data().charts[0].datapoints; let index = index"
            is="clx-group"
            [value]="datapoint"
            [draggable]="true"
        >
            <benchmark-datapoint-row
                [data]="datapoint"
                (deleted)="deleteDatapoint($event)"
                (valueChanged)="updateDatapoint($event)"
                [systemId]="systemId"
                [isSystemMode]="isSystemMode"
                [changeHandler]="onChange"
                [chartType]="'bar'"
                has="left-side-button"
                [test-id]="'benchmark-dashboard.tile-properties.window.datapoint.' + index"
            ></benchmark-datapoint-row>
        </clx-list-item>
    </clx-sortable-list>
</cx-window>